import type { LogisticsContent } from '../../types';

// 2026 logistics for the Andaz Miami Beach, from the preliminary program. WiFi
// details are still to come.
export const logistics: LogisticsContent = {
  intro:
    'Everything you need to know about getting to and attending the AGM in Miami',
  attire: 'Business casual attire recommended',
  notes: [
    'Breakfast and lunch are provided onsite on Tuesday, followed by cocktails and the LP dinner (5:30–8pm).',
    'Please email any dietary restrictions or food allergies to rsvp@twobearcapital.com.',
    'Questions? Contact Kevin Day, Head of Capital Formation, at rsvp@twobearcapital.com.',
  ],
  venue: {
    name: 'Andaz Miami Beach',
    addressLines: ['4041 Collins Avenue', 'Miami Beach, FL 33140'],
    note: "Tuesday's program takes place at the Andaz. Final session timings and locations will be shared closer to the event.",
    mapQuery: 'Andaz Miami Beach, 4041 Collins Avenue, Miami Beach, FL 33140',
  },
  hotels: [
    {
      name: 'Andaz Miami Beach',
      description:
        'Event venue hotel. Please reserve through our hotel block by October 31st; availability is limited. For reservation assistance or dates outside the block, contact rsvp@twobearcapital.com.',
      rate: 'From $484 per room, per night, including the resort fee and excluding taxes',
      bookingUrl:
        'https://www.hyatt.com/events/en-US/group-booking/MIAOB/G-BEI1',
    },
  ],
  transportation: [
    {
      icon: 'plane',
      title: 'By Air',
      lines: [
        'Miami International Airport (MIA) serves the area',
        'Rideshare services are available for airport transfers',
      ],
    },
    {
      icon: 'transit',
      title: 'Local Transportation',
      lines: [
        "Rideshare services are available around Miami Beach. Tuesday's program takes place at the Andaz; optional Monday dinners will be nearby, with locations provided once confirmed.",
      ],
    },
  ],
  restaurants: [
    {
      name: 'Donna Mare',
      cuisine: 'Italian chophouse',
      address: '3921 Collins Ave, Miami Beach',
    },
    {
      name: "Sunny's",
      cuisine: 'Modern steakhouse',
      description: 'A modern steakhouse with timeless appeal',
      address: '7357 NW Miami Ct, Miami',
    },
    {
      name: 'Campo at Casa Faena',
      cuisine: 'Latin / New American',
      address: '3500 Collins Ave, Miami Beach',
    },
    {
      name: 'Bazaar Meat by José Andrés',
      cuisine: 'Tapas • At the Andaz',
      description:
        'Tapas with Spanish, Asian & island tastes, plus wine & cocktails',
      address: '4041 Collins Ave, Miami Beach',
    },
    {
      name: 'Hakkasan Miami',
      cuisine: 'Modern Cantonese & dim sum',
      address: '4441 Collins Ave, Miami Beach',
    },
    {
      name: 'Nobu Miami',
      cuisine: 'Sushi & Japanese-Peruvian',
      address: '4525 Collins Ave, Miami Beach',
    },
  ],
};
